module.exports = __webpack_public_path__ + "static/media/9.question_loop.e5705fdf.mp4";